module.exports = __webpack_public_path__ + "media/assets/images/add-d4547011f69a9a5700f9641ae79007e8.svg";